export type StartPayloadLike = {
  sellerId?: number
  home?: {
    action?: string | null
  } | null
}

export function actionToNext(action: any): string {
  const a = String(action || '').trim().toLowerCase()

  if (a === 'community') return '/community'
  if (a === 'offers') return '/offers'
  if (a === 'home') return '/home'
  if (a === 'about') return '/about'
  if (a === 'courses') return '/courses'

  if (a.startsWith('/')) return a
  if (a.startsWith('http://') || a.startsWith('https://')) return a

  return '/community'
}

export function resolveAuthNextFromStartPayload(data: StartPayloadLike | null | undefined): string {
  return actionToNext(data?.home?.action)
}